require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./first-dmgt-doc.json") })
        }
      }, "path---first-dmgt-doc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---first-dmgt-doc!./.cache/json/first-dmgt-doc.json
// module id = 383
// module chunks = 231608221292675